import gql from "graphql-tag";
import { arrayOf, bool, number, shape, string } from "prop-types";

export default gql`
	query getSubscriptions {
		getSubscriptions {
			subscriptionID
			expirationDate
			allowedActivations
			isAutoBillingEnabled
			isTrial
			status
			serialNumbers {
				licenseName
				serialNumber
			}
			plan {
				name
				planCode
			}
			lastOrder {
				orderNumber
				isSerialNumberGenerationPending
			}
		}
	}
`;

export const readSubscriptions = ({ data }) => data && data.getSubscriptions;

export const activationPropTypes = shape({
	id: string,
	status: string,
	version: string,
	activated: string,
	deactivated: string,
	computerName: string,
});

export const downloadsPropTypes = shape({
	id: string,
	os: string,
	release: string,
	downloadLink: string,
	releaseDate: string,
	architectures: string,
	minOSVersion: string,
	minOSName: string,
});

export const serialNumbersPropTypes = arrayOf(
	shape({
		serialNumberID: number,
		serialNumber: string,
		licenseName: string,
		activations: arrayOf(activationPropTypes),
		downloads: arrayOf(downloadsPropTypes),
		adminEmails: arrayOf(
			shape({
				id: number,
				adminEmail: string,
			}),
		),
	}),
);

export const paymentMethodPropTypes = shape({
	address1: string,
	address2: string,
	address3: string,
	city: string,
	company: string,
	countryID: string,
	country: shape({
		name: string,
	}),
	email: string,
	firstName: string,
	labName: string,
	lastName: string,
	phone: string,
	require_display_name: bool,
	require_tld: bool,
	state: string,
	zipCode: string,
});

export const subscriptionPropTypes = shape({
	subscriptionID: number,
	expirationDate: string,
	status: string,
	archiveBit: bool,
	serialNumbers: serialNumbersPropTypes,
	plan: shape({
		name: string,
	}),
	paymentMethod: paymentMethodPropTypes,
});
